import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, map, take, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

// services
import { AuthenticationService } from '../service/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor (
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        return this.authenticationService.currentUser().pipe(
          take(1), // Asegura que se complete después de recibir el primer valor.
          map(user => {
            if (user) {
              const requiredNivelAcceso = route.data['requiredNivelAcceso']; // Accede al rol requerido de la ruta
    
              // Verifica si el usuario tiene el rol necesario
              if (requiredNivelAcceso && user.nivel_acceso !== requiredNivelAcceso) {
                // Si no tiene el rol necesario, redirige a una página de acceso denegado
                this.router.navigate(['auth/login']);
                return false;
              }
    
              // Usuario autenticado y con el rol necesario, permite acceso
              return true;
            }
            // Usuario no autenticado, redirige a login
            //this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } });
            this.router.navigate(['auth/login']);
            return false;
          }),
          catchError(error => {
            // Manejo de error, redirige a login
            console.error('Error en la autenticación', error);
            //this.router.navigate(['auth/login'], { queryParams: { returnUrl: state.url } });
            this.router.navigate(['auth/login']);
            return of(false);
          })
        );
      }
}